module.exports = __webpack_public_path__ + "img/circle-1.2.20d3db1b.svg";